import * as React from "react";
const SvgFiRrVrCardboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 3H5C2.243 3 0 5.243 0 8v8c0 2.757 2.243 5 5 5h2.352c1.062 0 2.056-.57 2.592-1.488l1.189-2.039a.99.99 0 0 1 .867-.499c.174 0 .605.048.867.499l1.19 2.039A3.01 3.01 0 0 0 16.648 21H19c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5m3 13c0 1.654-1.346 3-3 3h-2.352a1 1 0 0 1-.863-.496l-1.189-2.039A2.98 2.98 0 0 0 12 14.974a2.98 2.98 0 0 0-2.596 1.491l-1.188 2.039c-.179.306-.51.496-.864.496H5c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-5.5-9C14.57 7 13 8.57 13 10.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5S18.43 7 16.5 7m0 5c-.827 0-1.5-.673-1.5-1.5S15.673 9 16.5 9s1.5.673 1.5 1.5-.673 1.5-1.5 1.5m-9-5C5.57 7 4 8.57 4 10.5S5.57 14 7.5 14s3.5-1.57 3.5-3.5S9.43 7 7.5 7m0 5c-.827 0-1.5-.673-1.5-1.5S6.673 9 7.5 9 9 9.673 9 10.5 8.327 12 7.5 12"
    />
  </svg>
);
export default SvgFiRrVrCardboard;
